import { GenerateABDFDTData } from "@/api/generate-abd-fdt";
import { OPMFATData } from "@/api/opm-fat";
import { OPMFDTData } from "@/api/opm-fdt";

export function canDownload(
  opmFdts?: OPMFDTData[],
  opmFats?: OPMFATData[],
  abdFdts?: GenerateABDFDTData[],
  abdFats?: number,
) {
  return (
    opmFdts?.length === abdFdts?.length &&
    opmFats?.length === abdFats &&
    opmFdts?.every(
      (opmFdt) =>
        opmFdt?.poleFdt &&
        opmFdt?.imageFdt &&
        opmFdt?.outputFdt &&
        opmFdt?.inputFdt,
    ) &&
    opmFats?.every(
      (opmFat) => opmFat?.poleFat && opmFat?.imageFat && opmFat?.outputFat,
    )
  );
}
